const bostikBlue = '#2d4691';
const bostikGreen = '#a2bd30';
const bostikYellow = '#FC0';
const bostikDark = '#3d3d3d';

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Work sans', // 'Helvetica Neue',
  headerBgColor: bostikBlue,
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: bostikGreen,
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',

  starColor: bostikYellow,  // bostik star jaune
  resetFontColor: bostikDark,
};

const inputStyle = {
  fontFamily: 'Work sans, Arial',
  fontSize: '14px',
};
const customStyle = {
  background: 'transparent',
  borderRadius: '0',
  boxShadow: 'none',
  margin: '0 auto',
  padding: '0',
  flex: '1',
};
export default theme;
export {inputStyle,customStyle};